<template>
  <div>
    <img class="cursor-pointer" :src="imgListFilter(classify)" alt="" @click="viewImg" />
    <el-image
      v-show="false"
      ref="elImage"
      :src="imgContent"
      :preview-src-list="imgPreviewList"
    ></el-image>
  </div>
</template>

<script>
import { FileApi } from '@wiz-api/file-management'

const fileApi = new FileApi()
export default {
  name: 'table-view-img',
  props: {
    classify: {
      type: Number,
      default: null,
    },
    imgStr: {
      type: String,
      default: '',
    },
  },
  computed: {
    imgListFilter() {
      return (val) => {
        return (
          this.imgList.filter((item) => {
            return item.value === val
          })[0]?.type || require('@/assets/images/tools_images/GRFH.jpg')
        )
      }
    },
  },
  data() {
    return {
      // 工器具管理-类型对应的图标
      imgList: [
        { label: '个体防护装备', value: 0, type: require('@/assets/images/tools_images/GRFH.jpg') },
        {
          label: '绝缘安全工器具',
          value: 1,
          type: require('@/assets/images/tools_images/JYFH.jpg'),
        },
        { label: '登高工器具', value: 2, type: require('@/assets/images/tools_images/GK.jpg') },
        { label: '警示标识', value: 3, type: require('@/assets/images/tools_images/JSBS.jpg') },
      ],
      imgPreviewList: [],
      imgContent: null,
    }
  },
  methods: {
    async viewImg() {
      if (!this.imgStr) {
        this.$message({
          showClose: true,
          message: '暂无工器具图片',
          type: 'warning',
        })
        return
      }
      // 获取图片内容
      const [error, result] = await fileApi.getFileContent(this.imgStr)
      if (!error) {
        this.imgPreviewList.push(`data:image/jpg;base64,${result.content}`)
        this.imgContent = `data:image/jpg;base64,${result.content}`
        this.$nextTick(() => {
          this.$refs.elImage.clickHandler()
        })
      }
    },
  },
}
</script>
